import { axiosAuth } from "lib/axios"

export const verifyExistance = async (email, vat) => {
    return axiosAuth.get(`/auth/verify?email=${email}&vat=${vat}`)
}